import { render, staticRenderFns } from "./WorkflowStep.vue?vue&type=template&id=5ffb56dc&scoped=true"
import script from "./WorkflowStep.vue?vue&type=script&lang=js"
export * from "./WorkflowStep.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStep.vue?vue&type=style&index=0&id=5ffb56dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb56dc",
  null
  
)

export default component.exports